// DS: i4.16
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const NotificationOutline: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 24">
      <g transform="translate(2 2)">
        <path
          fillRule="evenodd"
          d="m14.502 4.93-.015-.058-.019-.057-.025-.073a2.1 2.1 0 0 0-.878-1.067l-1.323-.805A3.14 3.14 0 0 0 11.173.788 3.3 3.3 0 0 0 9 0a3.3 3.3 0 0 0-2.173.788A3.14 3.14 0 0 0 5.758 2.87l-1.323.805a2.1 2.1 0 0 0-.903 1.14l-.019.056-.015.058q-.016.063-.027.116l-1.344 5.014L.615 11.57A2.1 2.1 0 0 0 0 13.056V14.5c0 1.16.94 2.1 2.1 2.1h13.8a2.1 2.1 0 0 0 2.1-2.1v-1.444a2.1 2.1 0 0 0-.615-1.485l-1.512-1.512-1.344-5.014zm-6.07-2.816C8.61 2.036 8.805 1.998 9 2c.195-.002.39.036.568.114l.01.005c.368.166.652.508.68 1.025l.002.083v.77a.002.002 0 0 1-.002.003q-.004.001-.001.004l2.269 1.38a.1.1 0 0 1 .039.045l.003.01.009.048 1.496 5.581a.1.1 0 0 0 .026.045l1.872 1.872a.1.1 0 0 1 .029.07V14.5a.1.1 0 0 1-.1.1H2.1a.1.1 0 0 1-.1-.1v-1.444a.1.1 0 0 1 .03-.071L3.9 11.113a.1.1 0 0 0 .026-.045l1.496-5.581.01-.048.003-.01a.1.1 0 0 1 .038-.045l2.27-1.38q.001-.003-.002-.004l-.002-.002v-.77q0-.043.002-.084c.028-.517.312-.859.68-1.025zM11 20a1 1 0 1 0 0-2H7a1 1 0 1 0 0 2z"
          clipRule="evenodd"
        ></path>
      </g>
    </svg>
  </IconWrap>
);
NotificationOutline.displayName = 'NotificationOutline';

export default NotificationOutline;
